import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ContentfulClientApiFast } from 'app/shared/resources/contentfulClientApiFast';

@Component({
    selector: 'sbw-tier3tnc',
    templateUrl: './tier3tnc.component.html',
    styleUrls: ['./tier3tnc.component.css']
})
export class Tier3tncComponent implements OnInit, OnChanges {

    @Input() showPopup: string = null
    @Output() showPopupChange = new EventEmitter()

    tiers = [new Tier("tier1", false, 'EC3ECON1'), new Tier("tier2", true, 'EC3FLEX1'), new Tier("tier3", false, 'EC3PREM1')]
    rows = ['refundable', 'amendable', 'portFlexibility', 'priorityBoarding', 'premiumLounge', 'meal', 'wifi'].map(k => new Row(k))

    content: FaresTiersTNCContent
    footnotes: string[]

    constructor(private contentful: ContentfulClientApiFast) { }

    ngOnInit() {
        this.contentful.getEntries<FaresTiersTNCContent>('faresTiersTnc')
            .subscribe(s => {
                this.content = s.items[0].fields
                this.rows = this.rows.filter(r => this.content[r.row]) //remove empty rows
                this.footnotes = (s.items[0].fields.footnotes || '').split("\n")
            })
    }

    ngOnChanges(changes: SimpleChanges) {
        let { showPopup } = changes
        if (!showPopup) return
        let product: string = showPopup.currentValue
        this.tiers.forEach(t => t.setExpanded(product))
    }

}

export class Tier {
    name: string
    regex: RegExp
    constructor(public tier: string, public expanded: boolean, productPrefix: string) {
        this.name = tier + "Name"
        this.regex = new RegExp('^' + productPrefix, 'i')
    }

    rotation() {
        return this.expanded ? "open" : ""
    }

    setExpanded(product: string) {        
        this.expanded = product && !!product.match(this.regex)
    }

}

class Row {
    constructor(base: string) {
        this.row = base + 'Row'
        let camel = base.substring(0, 1).toUpperCase() + base.substring(1)
        this.tier1 = 'tier1' + camel
        this.tier2 = 'tier2' + camel
        this.tier3 = 'tier3' + camel
    }

    row: string
    tier1: string
    tier2: string
    tier3: string
}

export class FaresTiersTNCContent {
    tier1Name: string;
    tier1Refundable: string;
    tier1Amendable: string;
    tier1PortFlexibility: string;
    tier1PriorityBoarding: string;
    tier1PremiumLounge: string;
    tier1Meal: string;
    tier1Wifi: string;
    tier2Name: string;
    tier2Refundable: string;
    tier2Amendable: string;
    tier2PortFlexibility: string;
    tier2PriorityBoarding: string;
    tier2PremiumLounge: string;
    tier2Meal: string;
    tier2Wifi: string;
    tier3Name: string;
    tier3Refundable: string;
    tier3Amendable: string;
    tier3PortFlexibility: string;
    tier3PriorityBoarding: string;
    tier3PremiumLounge: string;
    tier3Meal: string;
    tier3Wifi: string;
    footnotes: string;
    refundableRow: string;
    amendableRow: string;
    portFlexibilityRow: string;
    priorityBoardingRow: string;
    premiumLoungeRow: string;
    mealRow: string;
    wifiRow: string;
}
